import(/* webpackMode: "eager" */ "/app/app/[locale]/(static)/blog/not-found.tsx");
